import { FC, Fragment } from 'react';
// Redux
import { useAppSelector } from 'hooks/useStore';
// Selectors
import { selectQuiz } from 'store/quiz/quizSelectors';
// Models
import IQuiz from 'models/Quiz';
// Types
import QuizTypes from 'types/QuizTypes';
// Components
import AppBar from 'components/AppBar';
import SocialShare from 'components/SocialShare';
import { Button } from 'components/Buttons';
// Hooks
import useNavigateTo from 'hooks/useNavigateTo';
// Components
import PublicDevicePlayable from 'components/PublicDevicePlayable';
import QuestionsList from './QuestionsList';
// i18next
import { useTranslation } from 'react-i18next';

const ResultsPage:FC = () => {
  const { t } = useTranslation('common');

  const navigateTo = useNavigateTo();

  const quiz:IQuiz = useAppSelector(selectQuiz);

  return (
    <Fragment>
      <PublicDevicePlayable />
      <AppBar  />
      <div className="grow p-4 overflow-y-auto">
        <div className="flex items-center mb-4">
          <div style={{ width: 72 }}>
            <Button
              onClick={() => navigateTo('post-quiz')}
              size="small"
            >{t('common.back')}</Button>
          </div>
          <div className="grow flex justify-center items-center gap-3">
            <h2 className="font-bold text-center text-lg">{t('common.results')}</h2>
          </div>
          <div style={{ width: 72 }}></div>
        </div>
        {quiz.socialShareEnabled && (quiz.hashtags || quiz.socialShareURL || quiz.socialShareImage) ? (
          <div className="mb-4">
            {!!quiz.socialShareBonusValue && quiz.type !== QuizTypes.Poll && (
              <h3 className="text-center text-sm text-blue-500 font-bold mb-2 px-4">{t('quiz.leaderboardPage.earnAdditionalPoints', { points: quiz.socialShareBonusValue })}</h3>
            )}
            <SocialShare />
          </div>
        ) : null}
        <QuestionsList />
      </div>
    </Fragment>
  )
}

export default ResultsPage;
